"use strict";
/* THIS IS A GENERATED FILE */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkubanaVendorApiClient = void 0;
const BaseApiClient_1 = require("./BaseApiClient");
class SkubanaVendorApiClient extends BaseApiClient_1.BaseApiClient {
    async retrieveVendor(vendorId) {
        const path = `/v1/vendor/${vendorId || ""}`;
        return await this.request("get", path, undefined, undefined);
    }
    async retrieveVendorProducts(queryParams) {
        const path = `/v1/vendorproducts`;
        return await this.request("get", path, queryParams, undefined);
    }
    async retrieveVendors(queryParams) {
        const path = `/v1/vendors`;
        return await this.request("get", path, queryParams, undefined);
    }
    async editVendors(editVendorDtos) {
        const path = `/v1/vendors`;
        return await this.request("post", path, undefined, editVendorDtos);
    }
    async createVendors(putVendorDto) {
        const path = `/v1/vendors`;
        return await this.request("put", path, undefined, putVendorDto);
    }
    async retrieveVendorPaymentTerms(queryParams) {
        const path = `/v1/vendors/paymentterms`;
        return await this.request("get", path, queryParams, undefined);
    }
    async updateVendorPaymentTerms(dto) {
        const path = `/v1/vendors/paymentterms`;
        return await this.request("post", path, undefined, dto);
    }
    async createVendorPaymentTerm(queryParams) {
        const path = `/v1/vendors/paymentterms`;
        return await this.request("put", path, queryParams, undefined);
    }
    async updateVendorProducts(vendorProducts) {
        const path = `/v1/vendors/products`;
        return await this.request("post", path, undefined, vendorProducts);
    }
    async deletePricingTiers(vendorProductId, queryParams) {
        const path = `/v1/vendors/products/${vendorProductId || ""}/pricingtiers`;
        return await this.request("delete", path, queryParams, undefined);
    }
    async retrievePricingTiers(vendorProductId) {
        const path = `/v1/vendors/products/${vendorProductId || ""}/pricingtiers`;
        return await this.request("get", path, undefined, undefined);
    }
    async createPricingTiers(vendorProductId, pricingTiers) {
        const path = `/v1/vendors/products/${vendorProductId || ""}/pricingtiers`;
        return await this.request("put", path, undefined, pricingTiers);
    }
    async deleteUnitsOfMeasure(vendorProductId, queryParams) {
        const path = `/v1/vendors/products/${vendorProductId || ""}/unitsofmeasures`;
        return await this.request("delete", path, queryParams, undefined);
    }
    async retrieveUnitsOfMeasure(vendorProductId) {
        const path = `/v1/vendors/products/${vendorProductId || ""}/unitsofmeasures`;
        return await this.request("get", path, undefined, undefined);
    }
    async createUnitsOfMeasure(vendorProductId, unitsOfMeasure) {
        const path = `/v1/vendors/products/${vendorProductId || ""}/unitsofmeasures`;
        return await this.request("put", path, undefined, unitsOfMeasure);
    }
    async createVendorProduct(createDto) {
        const path = `/v1/vendors/vendorproduct`;
        return await this.request("put", path, undefined, createDto);
    }
}
exports.SkubanaVendorApiClient = SkubanaVendorApiClient;
